<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>

        <!-- 表单信息 -->
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="bus-ruleForm"
            label-position="top"
            :disabled="type==='see'"
        >
          <div class="formContent">

            <div class="main-title">模特信息</div>
            <el-row v-for="(item, index) in ModelTemplate.portrait" :key="index">
              <el-col :xl="8" :lg="8">
                <el-form-item :label="item.label" :prop="item.prop">
                  <template v-if="item.assembly_type === 'image_up'">
                    <div class="image" v-if="ruleForm[item.prop]&&ruleForm[item.prop].length>0">
                      <el-image :src="ruleForm[item.prop]"></el-image>
                      <div class="upload-span" >
                  <span class="upload-icon" @click.stop="handlePreview(ruleForm[item.prop])">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                        <span v-if="type!=='see'" class="upload-icon" @click.stop="handleRemove(item.prop)" style="margin-left: 20px">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                    <div v-if="!ruleForm[item.prop]">
                      <el-upload
                          :action="$Url"
                          list-type="picture-card"
                          :headers="headers"
                          :multiple="false"
                          :on-success="(response, file, fileList) => {return handleSuccess(response, file, fileList, item.prop)}"
                          :on-error="handleError"
                          :show-file-list="false">
                        <i class="el-icon-plus">
                          <div class="uploadtxt">请上传高清扫描件</div>
                        </i>
                      </el-upload>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xl="8" :lg="8" v-for="(item, index) in ModelTemplate.information" :key="index">
                <el-form-item :label="item.label" :prop="item.prop">
                  <el-input
                      :disabled="item.disabled"
                      class="selitem"
                      v-if="item.assembly_type === 'input'"
                      v-model="ruleForm[item.prop]"
                      :placeholder="'请输入'+ item.label"
                      :type="item.type"
                  ></el-input>
                  <el-select
                      class="selitem"
                      v-if="item.assembly_type === 'el_option'"
                      v-model="ruleForm[item.prop]"
                      :placeholder="'请选择'+ item.label"
                      clearable
                  >
                    <el-option
                        v-for="every in item.options"
                        :key="every.value"
                        :label="every.name"
                        :value="every.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xl="8" :lg="8" v-for="(item, index) in ModelTemplate.fileCollection" :key="index">
                <el-form-item :label="item.label" :prop="item.prop">
                  <template v-if="item.assembly_type === 'image_up'">
                    <div class="image" v-if="ruleForm[item.prop]&&ruleForm[item.prop].length>0">
                      <el-image :src="ruleForm[item.prop]"></el-image>
                      <div class="upload-span">
                        <span class="upload-icon" @click.stop="handlePreview(ruleForm[item.prop])">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span  v-if="type!=='see'" class="upload-icon" @click.stop="handleRemove(item.prop)" style="margin-left: 20px">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <el-upload
                          :action="$Url"
                          list-type="picture-card"
                          :headers="headers"
                          :multiple="false"
                          :on-success="(response, file, fileList) => {return handleSuccess(response, file, fileList, item.prop)}"
                          :on-error="handleError"
                          :show-file-list="false">
                        <i class="el-icon-plus">
                          <div class="uploadtxt">请上传高清扫描件</div>
                        </i>
                      </el-upload>
                    </div>
                  </template>
                  <template v-if="item.assembly_type === 'video_up'">
                    <div class="video_css" v-if="ruleForm[item.prop]&&ruleForm[item.prop].length>0">
                      <video width="220px" height="130px" controls="controls" :key="menuKey">
                        <source :src="$videoUrl + ruleForm[item.prop]" type="video/mp4"/>
                      </video>
<!--                      <el-progress-->
<!--                          v-if="videoFlag == true"-->
<!--                          type="line"-->
<!--                          :percentage="videoUploadPercent"-->
<!--                          style="margin-top: 30px"-->
<!--                      ></el-progress>-->
                      <div class="upload-span" >
                        <!--                        <span class="upload-icon" @click.stop="handlePreview(ruleForm[item.prop])">-->
                        <!--                          <i class="el-icon-zoom-in"></i>-->
                        <!--                        </span>-->
                        <span v-if="type!=='see'" class="upload-icon" @click.stop="handleRemove(item.prop)" style="margin-left: 20px">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <el-upload
                          class="avatar-uploader"
                          :headers="headers"
                          :action="$videoUpUrl"
                          :show-file-list="false"
                          :on-success="(response, file, fileList) => {return handleSuccess(response, file, fileList, item.prop)}"
                          :on-error="handleError"
                      >
                        <i class="el-icon-plus" style="font-size: 28px;">
                          <div class="uploadtxt">请上传视频大小不超过5M</div>
                        </i>
                      </el-upload>
                    </div>

                  </template>
                </el-form-item>
              </el-col>
            </el-row>

          </div>

        </el-form>
<!--        <div>-->
<!--          <div class="mztitle">免责声明：</div>-->
<!--          <div>-->
<!--            <el-checkbox v-model="checked" class="checkbox">-->
<!--              <span>勾选即代表同意</span><span>《XXXXXXXXXX》</span>-->
<!--            </el-checkbox>-->
<!--          </div>-->

<!--        </div>-->
        <div class="bus-btn" v-if="type!=='see'">
          <button class="btn" @click="submitForm('ruleForm')"
          >保存
          </button
          >
          <!--          <button class="btn next_btn" @click="submitForm('ruleForm', 'submit')"-->
          <!--          >提交-->
          <!--          </button-->
          <!--          >-->
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" top="20vh">
      <img
          :src="dialogImageUrl"
          alt=""
          style="
            max-height: 550px;
            max-width: 100%;
            margin: 0 auto;
            display: block;
          "
      />
    </el-dialog>
  </div>
</template>

<script>
import {ModelTemplate} from "@/utils/individualForm";
import {
  addContacts,
  editContacts, MemberModels_add, MemberModels_edit,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条

export default {
  components: {top, navMenu},
  name: "contactPerson",
  data() {
    return {
      uploadImgData: {busiName: 32},
      videoFlag: false,
      videoUploadPercent: 0,
      menuKey: 1,
      imageUrl: null,
      headers: {
        token: localStorage.getItem("token")
      },
      ModelTemplate: ModelTemplate,
      type: '',
      userdata: JSON.parse(localStorage.getItem("userdata")),
      active: 1,
      loading: false,
      ruleForm: {
        type: '',
        photo: '',
        name: '',
        gender: '',
        sign_company: '',
        height: '',
        weight: '',
        bust: '',
        waist: '',
        hipline: '',
        shoe_size: '',
        registered_company: '',
        native_place: '',
        permanent_address: '',
        mandate_file: '',
        ID_card_file: '',
        swimwear_facade_pic: '',
        swimwear_side_pic: '',
        swimwear_back_pic: '',
        interview_video: '',
        show_video: '',
        ID_number: '',
        face_feature_pic: '',
        graduation_colleges: '',
        diploma_pic: '',
      },
      rules: {
        photo: [{required: true, message: "请选择照片", trigger: ['blur', 'change']}],
        name: [{required: true, message: "请输入姓名", trigger: ['blur', 'change']}],
        gender: [{required: true, message: "请选择性别", trigger: ['blur', 'change']}],
        sign_company: [{required: true, message: "请输入签约单位", trigger: ['blur', 'change']}],
        height: [{required: true, message: "请输入身高", trigger: ['blur', 'change']}],
        weight: [{required: true, message: "请输入体重", trigger: ['blur', 'change']}],
        bust: [{required: true, message: "请输入胸围", trigger: ['blur', 'change']}],
        waist: [{required: true, message: "请输入腰围", trigger: ['blur', 'change']}],
        hipline: [{required: true, message: "请输入臀围", trigger: ['blur', 'change']}],
        native_place: [{required: true, message: "请输入籍贯", trigger: ['blur', 'change']}],
        ID_number: [{required: true, message: "请输入身份证号码", trigger: ['blur', 'change']}],
        permanent_address: [{required: true, message: "请输入常驻工作地点", trigger: ['blur', 'change']}],
        registered_company: [{required: true, message: "请输入注册单位", trigger: ['blur', 'change']}],
        mandate_file: [{required: true, message: "请上传委托书", trigger: ['blur', 'change']}],
        ID_card_file: [{required: true, message: "请上传身份证复印件", trigger: ['blur', 'change']}],
        face_feature_pic: [{required: true, message: "请上传素颜面部特写", trigger: ['blur', 'change']}],
        swimwear_facade_pic: [{required: true, message: "请上传泳装正面照", trigger: ['blur', 'change']}],
        swimwear_side_pic: [{required: true, message: "请上传泳装侧面照", trigger: ['blur', 'change']}],
        swimwear_back_pic: [{required: true, message: "请上传泳装背面照", trigger: ['blur', 'change']}],
        interview_video: [{required: true, message: "请上传面试视频", trigger: ['blur', 'change']}],
        show_video: [{required: true, message: "请上传演出视频", trigger: ['blur', 'change']}],
        shoe_size: [{required: true, message: "请输入鞋码", trigger: ['blur', 'change']}],
        // email: [{required: true, message: "请输邮箱", trigger: ['blur', 'change']}, {
        //   type: "email",
        //   message: "请输入正确的邮箱地址",
        //   trigger: ["blur", "change"],
        // },
        // ],
        // mobile: [{required: true, message: "请输入手机号", trigger: "blur"}, {
        //   pattern: /^1[3-9]\d{9}$/,
        //   message: "手机号码格式不正确",
        //   trigger: "blur",
        // },
        // ],

      },
      dialogVisible: false, // 预览图片弹框
      dialogImageUrl: "", // 预览图片地址
      mark: '',
      checked: true

    };
  },
  mounted() {

    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;

    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/conference";
    });

    this.active = index;
    this.type = this.$route.query.type;
    this.mark = this.$route.query.mark;

    if(this.$route.query.data){
      this.ruleForm = this.$route.query.data;
    }
    // let token = this.$store.state.token;
    // this.headers = {
    //   Authorization: token,
    // };
  },
  created() {

  },
  watch: {},
  methods: {

    //zhao 上传成功
    handleSuccess(response, file, fileList, field) {
      if(response.code==1){
        this.$message.success(response.msg)
        this.ruleForm[field] = response.data.uri
      }else {
        this.$message.error(response.msg)
      }
    },
    // zhao 上传失败
    handleError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //zhao  删除图片
    handleRemove(field) {
      console.log(this.ruleForm[field])

      this.ruleForm[field] = ""
    },
    //赵 预览图片 通用
    handlePreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },

    // 视频上传
    handleAvatarSuccess(res, file) {
      // 进度条恢复到初始状态
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      ++this.menuKey;
      // console.log(res)
      this.imageUrl = res.data.uri;
    },
    // 返回
    goBack() {
      this.$router.back();
    },
    //滑动到错误对应位置
    scrollToFormError() {
      // 获取第一个校验错误的元素
      const element = document.querySelectorAll(".el-form-item__error")[0];
      // 滚动到错误元素对应位置
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },


    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitInfo()
        }
      });
    },
    //新增或编辑
    submitInfo() {
      this.loading = true;
      let data = this.ruleForm;
      data.type = this.userdata.type;
      if (!data.model_long_id) {//新增
        this.addData(data)
      } else {//修改
        this.editData(data)
      }

    },
    //新增
    addData(data) {
      MemberModels_add(data).then((res) => {
        this.loading = false;
        if (res.code == 1) {

          this.$message.success("新增成功");
          // 返回上一页
          setTimeout(() => {
            this.goBack();
          }, 1000);
        } else {
          this.$message.warning(res.data.msg);
        }
      })
          .catch((err) => {
            this.loading = false;
          });
    },
    //编辑
    editData(data) {
      MemberModels_edit(data).then((res) => {
        this.loading = false;
        if (res.code == 1) {

          this.$message.success("编辑成功");
          // 返回上一页
          setTimeout(() => {
            this.goBack();
          }, 1000);
        } else {
          this.$message.warning(res.data.msg);
        }
      })
          .catch((err) => {
            this.loading = false;
          });
    }
  },
};
</script>

<style lang="scss" scoped>
.video_css{
  width: 220px;
  height: 130px;
  border-radius: 6px;
  position: relative;
  .upload-span{
    cursor:pointer;
    line-height: 0px;
    position: absolute;
    top: 10%;
    right: 10%;
  }
}
.image {
  width: 148px;
  height: 130px;
  border-radius: 6px;
  position: relative;

  /deep/ .el-image {
    width: 148px;
    height: 130px;
  }

  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;

    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }

  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

.checkbox {
  margin-top: 10px;
}

.mztitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #7F8FA4;
  padding-top: 20px;
}

.content {
  padding-bottom: 40px;

  .formContent {
    width: 100%;
    height: 700px;
    overflow: auto;
  }

  .main-title {
    margin: 30px 0 0;
    padding-bottom: 18px;
    border-bottom: 1px solid #F0F2F5;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #354052;
  }

  .bus-ruleForm {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .el-row {
      width: 100%;
    }

    .el-form-item {
      width: 96%;
      margin-right: 60px;

      .el-select,
      .el-cascader {
        width: 100%;
      }

      .select {
        color: #1677ff;
        border-color: #1677ff;
      }

      .el-textarea__inner {
        border-radius: 9px;
      }
    }
  }
}

.bus-btn {
  text-align: center;

  .el-button {
    position: inherit;
    transform: translateX(0);
  }

  .save-draft {
    color: #2690E6;
    background: #fff;
    border: 1px solid #008DFF;
  }
}
</style>
<style lang="scss">
@media only screen and (max-width: 767px) {
}
</style>